import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  verticalBarArea: {
    backgroundColor: '#e0e0e0',
    padding: 10,
    height: '100%',
    color: '#606060'
  },
  circularArea: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    flexDirection: 'column'
  }
}))

export default useStyles
